export default "__VITE_ASSET__Bwhnwcmg__"